import { Link } from "react-router-dom";
import { ArrowRight, Clock, GraduationCap, School } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";
import { TAGLINE, SUPPORT_LINE, OFFER_END, OFFER_END_LABEL, useCountdown, pad } from "@/lib/offer";

const Unit = ({ v, l, testid }) => (
  <div className="flex flex-col items-center min-w-[2.6rem]" data-testid={testid}>
    <span className="text-lg font-black font-['Outfit'] tabular-nums">{pad(v)}</span>
    <span className="text-[9px] uppercase tracking-widest opacity-70">{l}</span>
  </div>
);

export const OfferPoster = () => {
  const { L } = useLang();
  const t = useCountdown(OFFER_END);
  return (
    <div className="relative w-full max-w-[340px] rounded-[1.75rem] overflow-hidden bg-[#0A192F] text-white shadow-[0_40px_90px_-30px_rgba(10,25,47,0.8)] border border-white/10 rs-poster-in" data-testid="offer-poster">
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-[#FF3B3B]/40 blur-3xl" />
      <div className="absolute -bottom-20 -left-10 w-56 h-56 rounded-full bg-[#00E5FF]/25 blur-3xl" />
      <div className="relative p-4 sm:p-5">
        <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.2em] bg-[#FF3B3B] px-3 py-1 rounded-full" data-testid="offer-poster-badge">
          <Clock className="w-3 h-3" />{L("Limited-time admission offer", "सीमित समय का दाखिला ऑफ़र")}
        </span>
        <h2 className="mt-3 text-2xl sm:text-[2rem] font-black leading-[1.02] font-['Outfit']" data-testid="offer-poster-tagline">{L(...TAGLINE)}</h2>
        <p className="mt-2 text-xs text-[#9BE9F5] font-semibold tracking-wide">{L(...SUPPORT_LINE)}</p>
        <div className="mt-4 grid grid-cols-2 gap-2.5">
          <div className="rounded-2xl bg-white/10 border border-white/15 p-3" data-testid="offer-poster-students">
            <GraduationCap className="w-4 h-4 text-[#FFD166]" />
            <div className="mt-1 text-xl font-black font-['Outfit'] text-[#FFD166]">50% / 70%</div>
            <div className="text-[11px] opacity-80">{L("off for new students", "नए छात्रों के लिए छूट")}</div>
          </div>
          <div className="rounded-2xl bg-white/10 border border-white/15 p-3" data-testid="offer-poster-schools">
            <School className="w-4 h-4 text-[#00E5FF]" />
            <div className="mt-1 text-xl font-black font-['Outfit'] text-[#00E5FF]">20–30%</div>
            <div className="text-[11px] opacity-80">{L("off for new schools", "नए स्कूलों के लिए छूट")}</div>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between gap-3 rounded-2xl bg-black/25 px-4 py-2.5" data-testid="offer-poster-countdown">
          <span className="text-[11px] leading-tight opacity-80">{L("Valid till", "मान्य")}<br /><b className="text-white">{L(...OFFER_END_LABEL)}</b></span>
          <div className="flex gap-1">
            <Unit v={t.d} l={L("days", "दिन")} testid="offer-cd-days" /><Unit v={t.h} l={L("hrs", "घं")} testid="offer-cd-hours" />
            <Unit v={t.m} l={L("min", "मि")} testid="offer-cd-mins" /><Unit v={t.s} l={L("sec", "से")} testid="offer-cd-secs" />
          </div>
        </div>
        <Link to="/enroll" className="block mt-4">
          <Button className="w-full h-11 rounded-full rs-cta text-sm font-bold" data-testid="offer-poster-enroll-btn">{L("Enroll Now", "अभी दाखिला लें")} <ArrowRight className="w-4 h-4 ml-1" /></Button>
        </Link>
        <p className="mt-3 text-[10px] opacity-60 text-center">{L("New admissions only · Kits not included · Schools: ", "केवल नए दाखिले · किट शामिल नहीं · स्कूल: ")}<Link to="/schools#onboard" className="underline" data-testid="offer-poster-school-link">{L("onboard here", "यहाँ जुड़ें")}</Link></p>
      </div>
    </div>
  );
};
